import React, {Component} from 'react';
import {DISPATCH_ID, SERVICE_RESPONSE, config, ROLES, SERVICE_API, VIEW_NAME} from '../libs/utils/Const';
import {connect} from 'react-redux';
import {ApiClient} from "../libs/apiClient/ApiClient";
import {Modal} from './index';
import {Carousel} from '../components';
import CurrencyFormat from 'react-currency-format';

let modal = new Modal();
let apiClient = ApiClient.getInstance();

class ItemDetailsModal extends Component {

    state = {
        images: [],
    };

    changeQuantity = (item, event) => {
        const {itemsReducer : {deleteShoppingCart, addShoppingCart}} = this.props;
            let newQuantity =  event.nativeEvent.target.value;
            let onHand = item.OnHand;
            if(newQuantity > onHand) {
                newQuantity = onHand;
            }
            if(!newQuantity){
                deleteShoppingCart({item, deleteAll: false});
            }else{
                addShoppingCart({item, quantity: (newQuantity || '1')})
            }
        };

    changLocalQuantity = (item, event)=>{
        const {shoppingCartReducer: {items},itemsReducer: {items: itemDetails}} = this.props;
        let newQuantity =  event.nativeEvent.target.value;
        if(newQuantity < 0){
            newQuantity = 1
        }
        if (newQuantity % 1 == 0) {
            item.quantity = newQuantity;
            this.applyFilters(item);
        }else{
            return;
        }
        
    }

    applyFilters = data => {
        const {setItemDetailsSearch} = this.props;
        setItemDetailsSearch(data);
    };

    changeBackOrder= (item, addItem) => {
        const {itemsReducer : {deleteBackOrder, addBackOrder}} = this.props;
        if(addItem){
            addBackOrder({item, quantity: 1})
        }else{
            deleteBackOrder({item, deleteAll: false});
        }
    };

    render() {
        const {itemsReducer: {itemDetails, deleteShoppingCart}, view} = this.props;
        itemDetails.files = itemDetails.files || [];
        return (
            <div className="modal fade" id="itemDetails" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{border: "none", textAlign: 'center'}}>
                <div className="modal-dialog" role="document" style={{maxWidth: '75%', margin: '40px auto'}}>
                    <div className="modal-content">
                        <div className="modal-header" style={{backgroundColor: config.navBar.menuCategoriesBackground}}>
                            <h5 className="modal-title text-center" style={{color: config.navBar.textColor}}>Detalle</h5>
                            <button type="button" style={{color: config.navBar.textColor}} className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body bg3 row" style={{ backgroundColor: 'rgba(248,249,250,0.6)', margin: 0, marginBottom: 20, padding: 0 }}>
                            <div className='col-12 col-lg-6'>
                                <div className='row'>
                                    <div className='col-12' style={{margin: 0, padding: 0}}>
                                        <Carousel images={itemDetails.images || []} itemCode={itemDetails.ItemCode}/>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-lg-6 text-left' style={{color: 'rgb(124, 124, 125)', marginTop: 20}}>
                                <div>
                                    <a className="font-weight-bold">
                                        {itemDetails.ItemName}
                                    </a>
                                    <br />
                                    <a className="font-italic">
                                        {itemDetails.ItemCode}
                                    </a>
                                    <h6 className="card-subtitle font-weight-bold text-left" style={{fontSize: 20, color: config.itemsList.textPrice}}>
                                        {itemDetails.U_web === 0 || itemDetails.U_web === null || itemDetails.OnHand === '0.0' ?
                                            "Solicite su cotización" : 
                                            <CurrencyFormat 
                                                value={itemDetails.priceTax} 
                                                displayType={'text'} 
                                                thousandSeparator={true} 
                                                fixedDecimalScale={true} 
                                                decimalScale={2} 
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                        }
                                        {/* {itemDetails.U_web === 1 &&
                                            " más I.G.V."
                                        } */}
                                    </h6>
                                </div>
                                <div>
                                    <div>
                                        <a className="text-uppercase font-weight-bold">Descripción:</a>
                                    </div>
                                    <textarea className="detailisModal" id="itemDescription" style={{marginBottom: 15, border: 'none', width: '100%'}} disabled={true}
                                                value={itemDetails.UserText ? itemDetails.UserText : 'No hay descripción para este producto' }>
                                    </textarea>
                                    
                                    <div className='text-right' style={{padding: 0, marginBottom:10}}>
                                        {itemDetails.files.map( file => {
                                            return <a key={file} href={file.path} target="_blank" >
                                                <i className={config.icons.datasheet} style={{color: config.itemsList.iconColor, paddingRight: 5}}></i>
                                                <span style={{color: config.itemsList.iconColor}}>Ficha técnica</span>
                                            </a>
                                        })}
                                    </div>

                                    { view !== VIEW_NAME.BACK_ORDER_VIEW && <div style={{textAlign: "center"}}>
                                        <div className='row text-center' style={{margin: 'auto', padding: 0, width: '80%'}}>
                                            {itemDetails.U_web === 0 || itemDetails.U_web === null ?
                                                <div className='col-12' style={{padding:0}}>
                                                    <label style={{textAlign: 'center', marginTop: 12, fontSize: 16}}>Llámenos o envíe un correo para cotización</label>
                                                </div> : 
                                                <div className='col-10'>
                                                    <input
                                                        // disabled={!(!!itemDetails.OnHand)}
                                                        disabled={itemDetails.OnHand >=1 ? false : itemDetails.OnHand === '0.0' ? true : true}
                                                        id={'input-quantity-details-' + itemDetails.ItemCode}
                                                        type="number"
                                                        min="1"
                                                        className="form-control"
                                                        name={'quantity' + itemDetails.ItemCode}
                                                        placeholder="Cantidad"
                                                        value={itemDetails.quantity ? Number(itemDetails.quantity) : ''}
                                                        style={{textAlign: 'center', marginTop: 8}}
                                                        // onChange={(event) => {this.changeQuantity(itemDetails, event)}}
                                                        onChange={(event) => {this.changLocalQuantity(itemDetails, event)}}
                                                    />
                                                </div>
                                            }
                                            {itemDetails.U_web === 1 &&
                                                <div className='col-2' style={{color: 'red', fontSize: 30, padding: 0}}>
                                                    {itemDetails.quantity && <i className="fa fa-trash" style={{cursor: 'pointer'}} onClick={() => deleteShoppingCart({item: itemDetails, deleteAll: false})}/>}
                                                </div>
                                            }
                                        </div>
                                        {itemDetails.U_web === 0 || itemDetails.U_web === null ?
                                            <div><br/></div>:
                                            <div className="col-10 text-center pt-1" style={{marginLeft: 'auto', marginRight: 'auto'}}>
                                                <button type="button" disabled={itemDetails.OnHand >=1 ? false : itemDetails.OnHand === '0.0' ? true : true} className="btn btn-success btn-block" value={(itemDetails.quantity ? Number(itemDetails.quantity): '1')} onClick={(event)=>{this.changeQuantity(itemDetails, event)}}>
                                                    <i className={config.icons.add}/> Agregar al carrito
                                                </button>
                                            </div>
                                        }
                                        {itemDetails.U_web === 1 &&
                                            itemDetails.wishlist === 1 &&
                                            <div className='row text-center' style={{margin: 'auto', padding: 0, width: '80%'}}>
                                                <div className='col-8'>
                                                    <label style={{textAlign: 'center', marginTop: 12}}>Lista de deseos</label>
                                                </div>
                                                <div className='col-2' style={{color: 'rgb(13, 98, 168)', fontSize: 30, padding: 0}}>
                                                    { itemDetails.backOrder ? 
                                                        <i className='fa fa-minus' style={{cursor: 'pointer', marginLeft: 7}} onClick={() => this.changeBackOrder(itemDetails, false)}/> :
                                                        <i className='fa fa-plus' style={{cursor: 'pointer', marginLeft: 7}} onClick={() => this.changeBackOrder(itemDetails, true)}/>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        notificationReducer: store.NotificationReducer,
        shoppingCartReducer: store.ShoppingCartReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setItemDetailsSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_ITEM_DETAILS, value}),
        setItemsSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_ITEMS, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ItemDetailsModal);
